// import React from 'react';
// import { useNavigate } from 'react-router-dom';
// import { AiFillStar } from 'react-icons/ai';
// import { IoIosArrowForward } from 'react-icons/io';
// import './CourseCard.css';

// const CourseCard = ({ image, title, description, category, rating, interviews, link }) => {
//   const navigate = useNavigate();

//   // const handleEnrollClick = () => {
//   //   navigate(link); // ✅ Navigate to the course page
//   // };
//     const handleEnrollClick = () => {
//     navigate(link);
//     setTimeout(() => window.scrollTo({ top: 0, behavior: "smooth" }), 100); // ✅ scroll to top after navigation
//   };

//   return (
//     <div className="course-card">
//       <div className="course-image-wrapper">
//         <img src={image} alt={title} className="course-image" />
//         <div className="course-badge">{category}</div>
//       </div>

//       <div className="course-content">
//         <div className="course-rating">
//           <AiFillStar size={16} color="currentColor" />
//           <span>{rating} Reviews</span>
//         </div>

//         <h3 className="course-title">{title}</h3>
//         <p className="course-description">{description}</p>

//         <div className="course-footer">
//           <div className="course-interviews">{interviews} Interviews</div>
//           <button className="course-btn" onClick={handleEnrollClick}>
//             Enroll Now <IoIosArrowForward size={16} />
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CourseCard;
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AiFillStar } from 'react-icons/ai';
import { IoIosArrowForward } from 'react-icons/io';
import './CourseCard.css';

const CourseCard = ({ image, title, description, category, rating, interviews, link }) => {
  const navigate = useNavigate();

  const handleEnrollClick = () => {
    navigate(link);
    setTimeout(() => window.scrollTo({ top: 0, behavior: "smooth" }), 100);
  };

  return (
    <div className="course-card" onClick={handleEnrollClick}>
      <div className="course-image-wrapper">
        <img src={image} alt={title} className="course-image" />
        <div className="course-badge">{category}</div>
      </div>

      <div className="course-content">
        <div className="course-rating">
          <AiFillStar size={16} color="currentColor" />
          <span>{rating} Reviews</span>
        </div>

        <h3 className="course-title">{title}</h3>
        <p className="course-description">{description}</p>

        <div className="course-footer">
          <div className="course-interviews">{interviews} Interviews</div>

          {/* You can remove onClick because card itself is clickable */}
          <button className="course-btn">
            Enroll Now <IoIosArrowForward size={16} />
          </button>

        </div>
      </div>
    </div>
  );
};

export default CourseCard;
